import { useParams, useEffect, useState, BiCategory, FaEye, Select, ToastContainer, MdErrorOutline, Tippy, MdInfo, TbNumbers, FaPercentage, FaLock, overlayStyle, loaderStyle, FaBoxOpen, TbTriangleSquareCircle, MdDomainVerification, FaArrowAltCircleRight, FaTrash, FaPlus, FaFilePdf, FaFileImage, FaFileExcel, FaFileAlt, FaFolderOpen, FaTimes } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import MidAddProducts from '../../middleware/Products/MidAddProducts';
import useNavigation from '../../common/useNavigation';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import { Modal } from "react-bootstrap";


const AddProducts = () => {
  const { type } = useParams();
  const [issidebarOpen, setIssidebarOpen] = useState(true);
  const { error } = useErrorContext();
  const { handlenavigateProducts, navigatePlans } = useNavigation();
  const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
  const { users, userPlan, Remainuser, subUser, handleProductDetailsSubmit, values, handleDetailsInputChange, handleCategoryChange, categories, selectedCategories, categoryData, disabledStatus, variationmodalShow, handlevariationmodalshow, handlevariationmodalhide, userAttributesarray, handleSellingUnit, handleVariantInput, handlevariantSave, packingtypedata, measurementdata, handlepackingtype, handleshippingpackingtype, offerdata, handleofferClick, filePreviews, uploadingStatus, isUploading, getInputProps, getRootProps, handleRemovePreview, handleProductPhotoSubmit, handlefinalProductSubmit, badges, selectedBadge, handleBadgeChange, warehouse, selectedwarehouse, handlewarehouseChange, variantvalues, handleVariantPhotoUpload, variants, fileTitle, setFileTitle, currentFile, uploadedFiles, fileInputRef, triggerFileInput, removeFile, handleAddDocument, handleFileChange, handleofferssubmit, handleofferChange, handleofferDelete, handleProductCategrySubmit, handleDocsSubmit, handleToggleVariantVisible, handleToggleVariantActive, isVariantVisible, isVariantActive, isLoading , variantError
  } = MidAddProducts(type);

  const [ActiveUser, setActiveUser] = useState(null); // ActiveUser ki initial state null
  useEffect(() => {
    if (Array.isArray(users) && users.length > 0) {
      setActiveUser(users[0]["Status"]); // ActiveUser ko state mein update karna
    }
  }, [users]); // Jab users update ho, yeh effect run karega

  // console.log({ variantvalues: variantvalues })

  if (Array.isArray(users) && users.length > 0) {
    var AppID = users[0]['AppID'];
    var ProfilePic = users[0]['ProfilePic'];
    var usertype = users[0]['UserType'];
    var username = users[0]['FullName'];
  }
  if (Array.isArray(userPlan) && userPlan.length > 0) {
    var planID = userPlan[0]['plan_id'];
  }

  // const outputbadges = badges.map((badge) => ({
  //   label: badge.name,
  //   value: badge.id,
  // }));


  // const outputwarehouse = warehouse.map((warehouse) => ({
  //   label: warehouse.name,
  //   value: warehouse.id,
  // }));



  // Move this part to middle ware 
  // State to manage all variants
  // const [variants, setVariants] = useState([]);

  // State to manage current variant fields


  // State to manage modal visibility
  // const [isModalOpen, setIsModalOpen] = useState(false);

  // Handle input change for current variant
  // const handleInputChange = (e, field) => {
  //   setCurrentVariant({
  //     ...currentVariant,
  //     [field]: e.target.value,
  //   });
  // };

  // Open modal
  // const openModal = () => {
  //   setIsModalOpen(true);
  // };

  // Close modal
  // const closeModal = () => {
  //   setIsModalOpen(false);
  // };

  // Add new variant panel
  // const addNewVariant = () => {
  //   if (
  //     currentVariant.sellingUnit &&
  //     currentVariant.sellingUnitPackingType &&
  //     currentVariant.shippingUnit &&
  //     currentVariant.shippingUnitPackingType &&
  //     currentVariant.productVariant &&
  //     currentVariant.productHSN &&
  //     currentVariant.productWarenty &&
  //     currentVariant.productMOQ
  //   ) {
  //     // setVariants([...variants, currentVariant]);
  //     setVariantValue([...variants, currentVariant]);
  //     setCurrentVariant({
  //       sellingUnit: "",
  //       sellingUnitPackingType: "",
  //       shippingUnit: "",
  //       shippingUnitPackingType: "",
  //       productVariant: "",
  //       productHSN: "",
  //       productWarenty: "",
  //       productMOQ: "",
  //       productPhoto: null, // Reset photo field
  //     });
  //     closeModal(); // Close modal after adding variant
  //   } else {
  //     alert("Please fill all fields before adding a new variant.");
  //   }
  // };

  // Handle form submission
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // console.log("All Variants with Photos:", variants);
  //   // Yahan aap API call ya koi aur logic add kar sakte hain

  const outputbadges = userAttributesarray.includes("29") ? badges.map((badge) => ({
    label: badge.name,
    value: badge.id,
  })) : [];

  const outputwarehouse = userAttributesarray.includes("30") ? warehouse.map((wh) => ({
    label: wh.name,
    value: wh.id,
    status:wh.status,
  })) : [];


  console.log({disabledStatus:disabledStatus})

  return (
    <div className="md:flex md:flex-row md:w-full">
      <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
        <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
      </div>
      <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
        <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
        <ToastContainer />
        <div className="w-full ">
          <div className="col-start-1 col-end-13">
            <div className=" p-2 text-xl text-[#1e3a8a]">
              <div className='px-3'>
                <h1 className=' text-lg text-theme-color-text font-bold'> Products</h1>
                <p className=' text-gray-600 text-[16px] '>select attributes as per your products range, code, name and category are required attributes. you have to an option to include all attributes while adding product data but displaying only few of them to your buyers.  </p>
              </div>
            </div>

            {ActiveUser === null ? (
              <div>Loading...</div>   // ya empty fragment <> </>
            ) : ActiveUser === 1 ? (
              <div className="border-0 flex-row rounded-xl m-3 px-3 bg-white shadow-xs">
                <div className='p-3 mb-3'>


                  <div className='flex flex-row justify-between items-center my-1'>
                    <h5 className=" capitalize text-xl font-bold mb-0">Add New Product</h5>
                    <button type="submit" className="relative rounded-md group px-3 h-12 flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[200px]" onClick={handlenavigateProducts}>
                      <span className="relative text-md text-black font-semibold pl-0">View All Products</span>
                      <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                        <FaEye className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                      </div>
                    </button>
                  </div>
                  {/* Main Content */}

                  {/* Product Details Section start */}
                  <div className='bg-white relative border-[1px] border-solid border-[#e5e5e5] rounded-md my-2'>

                    <div>
                      <div className='flex flex-row justify-between items-center py-3 bg-[#e9f3fe]'>
                        <h5 className="text-black capitalize text-md font-semibold mx-3"> Product Details </h5>
                        {/* <div className='flex justify-end'>
                        <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" > Edit  </Button>
                      </div> */}
                      </div>

                      {(!disabledStatus.productDetails) ?
                        <div className="p-3">
                          <div className=" space-y-4">
                            <div className=" p-4 rounded-lg  w-full ">
                              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-sm">
                                {/* Data Section */}

                                <div>
                                  <p>
                                    <span className="font-medium text-[#444050]" >Product Code / SKU:</span>
                                  </p>
                                  <h5 className='text-[#6d6b77] my-2'>
                                    {values.productCode}
                                  </h5>
                                </div>
                                <div>
                                  <p>
                                    <span className="font-medium text-[#444050]" >Product GST/VAT/TAX</span>
                                  </p>
                                  <h5 className='text-[#6d6b77] my-2'>
                                    {values.productTax} %
                                  </h5>
                                </div>


                                <div>
                                  <p>
                                    <span className="font-medium text-[#444050]" >Badge:</span>
                                  </p>
                                  <h5 className='text-[#6d6b77] my-2'>
                                    {selectedBadge?.label || 'Not selected'}
                                  </h5>
                                </div>

                                <div>
                                  <p>
                                    <span className="font-medium text-[#444050]" >warehouse:</span>
                                  </p>
                                  <h5 className='text-[#6d6b77] my-2'>
                                    {selectedwarehouse?.label || 'Not selected'}
                                  </h5>
                                </div>


                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-1 gap-4 text-sm">
                                {/* Data Section */}
                                <div className="col-span-1">
                                  <p>
                                    <span className="font-medium text-[#444050]" > Product Name :</span>
                                  </p>
                                  <h5 className='text-[#6d6b77] my-2'>
                                    {values.productName}
                                  </h5>

                                </div>
                              </div>
                              <div className="grid grid-cols-1 md:grid-cols-1 gap-4 text-sm">
                                {/* Data Section */}
                                <div className="col-span-1">

                                  <p>
                                    <span className="font-medium text-[#444050]" >Short Description :</span>
                                  </p>
                                  <h5 className='text-[#6d6b77] my-2'>
                                    {values.shortdescription}
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> :

                        <div className="p-3">
                          <form method='POST'>
                            <div className='row'>
                              <div className="m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2 rounded-lg my-2">
                                {/* Product Code / SKU */}
                                <div>
                                  <label className="my-3 flex flex-row">
                                    <span className="block text-sm font-medium text-slate-700"> Product Code / SKU </span>
                                    <Tippy content={<span> SKU (Stock Keeping Unit) is a user-defined alphanumeric code that uniquely identifies a product based on its type, size, color, weight, packaging, or other criteria set by the user. SKUs streamline inventory management, facilitate order processing, and enable accurate product tracking throughout the sales cycle. </span>}><button className="mx-3"><MdInfo /></button></Tippy>
                                  </label>
                                  <div className='flex bg-white relative my-2 border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                    <TbNumbers className='text-theme-color-yellow' />
                                    <input
                                      className=" ml-2 pl-2 focus:outline-none w-full pr-6 "
                                      type="text"
                                      name="productCode"
                                      id="productCode"
                                      placeholder="Enter Product Code/SKU"
                                      autoComplete="new-password"
                                      value={values.productCode}
                                      onChange={handleDetailsInputChange}
                                      required
                                    />
                                    {error.productCode &&
                                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                    }
                                  </div>
                                  {error.productCode &&
                                    <p className='my-2 px-2 text-red-600 text-xs'>{error.productCode}</p>
                                  }
                                </div>

                                {/* Product Name */}
                                <div>
                                  <label className="block my-3">
                                    <span className="block text-sm font-medium text-slate-700">Product Name </span>
                                  </label>
                                  <div className="flex  bg-white relative my-2 border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                    <BiCategory className=' text-theme-color-yellow' />
                                    <input
                                      className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                      type="text"
                                      name="productName"
                                      id="productName"
                                      placeholder="Enter Product Name"
                                      autoComplete="new-password"
                                      value={values.productName}
                                      onChange={handleDetailsInputChange} />
                                    {error.productName &&
                                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                    }
                                  </div>
                                  {error.productName &&
                                    <p className='my-2 px-2 text-red-600 text-xs'>{error.productName}</p>
                                  }
                                </div>

                                {/* Select Badges */}
                                {userAttributesarray.includes("29") ?
                                  <div>
                                    <div>
                                      <label className="block text-sm font-medium text-gray-700 my-3">
                                        Select Badges
                                      </label>
                                      <Select

                                        // isMulti
                                        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                        options={outputbadges} // Pass the badges array as options
                                        value={selectedBadge} // Set the selected value
                                        onChange={handleBadgeChange} // Handle selection change
                                        placeholder="Select Badge" // Placeholder text
                                      />
                                    </div>
                                  </div> : null}
                                {/* Select Warehouse */}
                                {userAttributesarray.includes("30") ? <div>
                                  <div>
                                    <label className="block text-sm font-medium text-gray-700 my-3">
                                      Select warehouse
                                    </label>
                                   <Select
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  }}
  options={outputwarehouse.filter(item => item.status !== 0)}
  value={selectedwarehouse}
  onChange={handlewarehouseChange}
  placeholder="Select Warehouse"
/>

                                  </div>

                                </div> : null}

                                {/* Product GST/VAT */}
                                <div>
                                  <label className="block my-3">
                                    <span className="block text-sm font-medium text-slate-700">Product GST/VAT <span className="text-gray-600"> (in %)</span> </span>
                                  </label>
                                  <div className="flex bg-white relative my-2 border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                    <BiCategory className=' text-theme-color-yellow' />
                                    <input
                                      className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                      type="text"
                                      name="productTax"
                                      id="productTax"
                                      placeholder="Enter Product Tax"
                                      autoComplete="new-password"
                                      value={values.productTax}
                                      onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                      // onChange={handleDetailsInputChange} 
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        // Only update if ≤ 99
                                        if (value === "" || Number(value) <= 99) {
                                          handleDetailsInputChange(e);
                                        }
                                      }}
                                    />
                                    <FaPercentage className=' text-[#9ea0a5]' />

                                    {error.productTax &&
                                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                    }
                                  </div>
                                  {error.productTax &&
                                    <p className='my-2 px-2 text-red-600 text-xs'>{error.productTax}</p>
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className='flex flex-col   my-2'>
                                <div className=' w-full inline-block text-center '>
                                  <label className="my-3 flex flex-row">
                                    <span className="block text-sm font-medium text-slate-700"> Product Short Desciption </span>
                                    <Tippy content={<span> SKU (Stock Keeping Unit) is a user-defined alphanumeric code that uniquely identifies a product based on its type, size, color, weight, packaging, or other criteria set by the user. SKUs streamline inventory management, facilitate order processing, and enable accurate product tracking throughout the sales cycle. </span>}><button className="mx-3"><MdInfo /></button></Tippy>
                                  </label>
                                  <textarea
                                    className="w-full border border-[#e5e5e5] h-32 resize-none p-2 focus:outline-none focus:border-[#e5e5e5] hover:border-[#e5e5e5]"
                                    name="shortdescription"
                                    id="shortdescription"
                                    value={values.shortdescription}
                                    onChange={handleDetailsInputChange}
                                    placeholder="Enter your Product Short Description here..."
                                  />

                                </div>
                              </div>
                            </div>

                            {/* Submit Button */}
                            <div className='flex justify-end'>
                              {/* <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductDetailsSubmit}> Submit</Button> */}
                              <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductDetailsSubmit}> Save & Next </Button>
                            </div>
                          </form>
                        </div>}
                    </div>

                  </div>
                  {/* Product Details Section end */}
                  {/* Product category sections */}
                  <div className={`${disabledStatus.productCategories ? "bg-gray-200" : "bg-white"} my-2  rounded-md border-[1px] border-solid border-[#e5e5e5]`}>
                    <div className={`${!disabledStatus.productCategories ? "bg-[#e9f3fe]" : "my-3"} flex flex-row items-center py-3 `}>
                      {disabledStatus.productCategories && <FaLock className='text-gray-400 mx-2' />}
                      <h5 className={`${disabledStatus.productCategories ? "text-gray-400" : "text-black"} mx-3 capitalize text-md font-semibold`}> Product Categories </h5>
                    </div>
                    {!disabledStatus.productCategories &&
                      <div>
                        <div className="p-3">
                          <form method='POST'>
                            <div className='row'>
                              {/* Categories Dropdowns */}
                              <div className="">
                              {categories.length > 0 && (
  <div className="flex flex-wrap">
    {Array.from({ length: selectedCategories.length + 1 }).map((_, index) => {
      const currentCategory = selectedCategories[index];

      const rawOptions = categoryData[index] || categories;

      const selectOptions = rawOptions.filter(
        (option) => Number(option.status) !== 0
      );

      return (
        <div key={index} className="w-full md:w-1/5 p-1">
          <label className="block text-sm font-medium text-gray-700 my-3">
            {index === 0
              ? "Select Category"
              : `Select Sub Category ${index}`}
          </label>

          <Select
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            options={selectOptions}
            value={
              selectOptions.find(
                (option) => option.value === currentCategory
              ) || null
            }
            onChange={(selectedOption) =>
              handleCategoryChange(index, selectedOption)
            }
            placeholder={`Select Category ${index}`}
          />
        </div>
      );
    })}
  </div>
)}

                              </div>
                              

                            </div>

                            {/* Submit Button */}
                            <div className='flex justify-end'>
                              {/* <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductDetailsSubmit}> Submit</Button> */}
                              <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductCategrySubmit}>
                                {disabledStatus.productVariant ? 'Save & Next' : 'Update & Next'}
                              </Button>
                            </div>
                          </form>
                        </div>
                      </div>
                    }
                  </div>
                  {/* Product category section End  */}




                  {/* Product variant Section start */}
                  <div className={`${(disabledStatus.productVariant) ? "bg-gray-200" : "bg-white"} my-2 rounded-md border-[1px] border-solid border-[#e5e5e5] `}>
                    <div className={`${!disabledStatus.productVariant ? "bg-[#e9f3fe]" : "my-3"} flex flex-row items-center py-3 `}>
                      {disabledStatus.productVariant && <FaLock className='text-gray-400 mx-2' />}
                      <h5 className={`${disabledStatus.productVariant ? "text-gray-400" : "text-black"} mx-3 capitalize text-md font-semibold`}> Product Variations </h5>
                    </div>
                    {!disabledStatus.productVariant &&
                      <div className="p-3">
                        <div className="my-3 space-y-4">
                          {variants.map((variant, idx) => (
                            <div key={idx} className="bg-[#f1f1f1] p-4 rounded-lg  w-full">
                              <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-sm">
                                {/* Image Section */}
                                {variant.productPhoto && (
                                  <div className="col-span-1 flex items-center justify-center">
                                    <img
                                      src={URL.createObjectURL(variant.productPhoto)}
                                      alt="Product Variant"
                                      className="w-12 h-12 md:w-16 md:h-16 object-cover rounded"
                                    />
                                  </div>
                                )}

                                {/* Data Section */}
                                <div className="col-span-1">
                                  <p>
                                    <span className="font-medium text-[#444050]" >Selling Units:</span> {variant.sellingUnit}
                                  </p>
                                  <p>
                                    <span className="font-medium text-[#444050]" >Selling Unit Packing Type:</span> {variant.sellingUnitPackingType}
                                  </p>
                                </div>
                                <div className="col-span-1">
                                  <p>
                                    <span className="font-medium text-[#444050]" >Shipping Units:</span> {variant.shippingUnit}
                                  </p>
                                  <p>
                                    <span className="font-medium text-[#444050]" >Shipping Unit Packing Type:</span> {variant.shippingUnitPackingType}
                                  </p>
                                </div>
                                <div className="col-span-1">
                                  <p>
                                    <span className="font-medium text-[#444050]" >Variant:</span> {variant.productVariant}
                                  </p>
                                  <p>
                                    <span className="font-medium text-[#444050]" >HSN Code:</span> {variant.productHSN}
                                  </p>
                                </div>
                                <div className="col-span-1">
                                  <p>
                                    <span className="font-medium text-[#444050]" >Best Before / Expiry:</span> {variant.productWarenty}
                                  </p>
                                  <p>
                                    <span className="font-medium text-[#444050]" >Minimum Order Quantity:</span> {variant.productMOQ}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="flex justify-center ">
                          {!disabledStatus.productVariant && <Button className='bg-[#0d6efd] mx-2' variant="primary" size="sm" onClick={() => handlevariationmodalshow()} disabled={disabledStatus.productVariant}>Add More Product Variant </Button>}
                        </div>

                      </div>}
                  </div>

                  {/* Product Variant End */}
                  {/* Product PHotos start */}
                  <div className={`${disabledStatus.productPhoto ? "bg-gray-200" : "bg-white"} my-2 rounded-md border-[1px] border-solid border-[#e5e5e5]`}>


                    <div className={`${!disabledStatus.productPhoto ? "bg-[#e9f3fe]" : "my-3"} flex flex-row items-center py-3 `}>
                      {disabledStatus.productPhoto && <FaLock className='text-gray-400 mx-2' />}
                      <h5 className={`${disabledStatus.productPhoto ? "text-gray-400" : "text-black"} mx-3 capitalize text-md font-semibold`}> Product Photos </h5>
                    </div>

                    {!disabledStatus.productPhoto &&
                      <div className='p-3'>
                        {/* Drag and Drop Area */}
                        {filePreviews.length < 10 && (
                          <div
                            {...getRootProps()}
                            style={{
                              border: '2px dashed #ccc',
                              padding: '20px',
                              textAlign: 'center',
                              cursor: 'pointer',
                              marginBottom: '20px',
                            }}
                          >
                            <input
                              {...getInputProps()}
                              accept=".jpg,.jpeg,.png,.gif" // Only allow jpg, jpeg, png, gif
                            />
                            <p>Drag & drop images here, or click to select files</p>
                          </div>
                        )}

                        {/* Uploading Status */}
                        {uploadingStatus && <p>{uploadingStatus}</p>}

                        {/* Preview Images */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                          {filePreviews.length > 0 &&
                            filePreviews.map(({ file, preview }, index) => (
                              <div key={index} style={{ position: 'relative' }}>
                                <img
                                  src={preview}
                                  alt={`Preview-${index}`}
                                  style={{
                                    width: '100px',
                                    height: '100px',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    objectFit: 'cover',
                                  }}
                                />
                                <button
                                  onClick={() => handleRemovePreview(file)}
                                  style={{
                                    position: 'absolute',
                                    top: '5px',
                                    right: '5px',
                                    background: 'red',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  X
                                </button>
                              </div>
                            ))}
                        </div>

                        {/* Upload Button */}
                        {filePreviews.length > 0 && filePreviews.length <= 10 && (
                          <div className="flex justify-end mt-4">
                            <Button
                              type="submit"
                              className="bg-[#0d6efd] mx-2 btn btn-sm text-white"
                              onClick={handleProductPhotoSubmit}
                              disabled={isUploading || filePreviews.length > 10} // Disable if more than 10 photos
                            >
                              {isUploading ? 'Uploading...' : 'Upload & Next'}
                            </Button>
                          </div>
                        )}

                        {/* Max Limit Message */}
                        {filePreviews.length >= 10 && (
                          <p style={{ color: 'red', textAlign: 'center', marginTop: '10px' }}>
                            Maximum 10 photos allowed.
                          </p>
                        )}
                      </div>
                    }

                  </div>
                  {/* Product Photos End  */}
                  {/* Product Document Start  */}

                  <div className={`${disabledStatus.productDocument ? "bg-gray-200" : "bg-white"} my-2  rounded-md border-[1px] border-solid border-[#d2d2d2]`}>

                    <div className={`${!disabledStatus.productDocument ? "bg-[#e9f3fe]" : "my-3"} flex flex-row items-center py-3 `}>
                      {disabledStatus.productDocument && <FaLock className='text-gray-400 mx-2' />}
                      <h5 className={`${disabledStatus.productDocument ? "text-gray-400" : "text-black"} mx-3 capitalize text-md font-semibold`}> Product Documents </h5>
                    </div>
                    {/* {!disabledStatus.productDocument && (<UploadProductDocs data={uniqueID} onFileChange={(files) => onFileChange(files)} />)} */}
                    {!disabledStatus.productDocument &&
                      <div className="p-3 ">
                        <div className='container m-auto'>
                          {/* Document Title Input */}
                          <div className='flex relative my-4 border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                            <TbNumbers className='text-theme-color-yellow' />
                            <input
                              className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6"
                              type="text"
                              placeholder="Enter Document Title"
                              value={fileTitle}
                              onChange={(e) => setFileTitle(e.target.value)}
                              required
                            />
                          </div>

                          {/* Single Dropzone */}
                          <div className="drop-file-input relative w-full border-[1px] border-dashed border-gray-400 rounded-2xl hover:opacity-60 bg-gray-100 mb-4">
                            <div className='drop-file-input__label text-center text-theme-color-text font-semibold p-3'>
                              {currentFile ? (
                                <>
                                  {currentFile.type === 'pdf' ? (
                                    <FaFilePdf className='text-5xl text-[#d10707] m-auto' />
                                  ) : ['gif', 'jpg', 'jpeg', 'png', 'webp'].includes(currentFile.type) ? (
                                    <FaFileImage className='text-5xl text-[#e79d11] m-auto' />
                                  ) : currentFile.type === 'xlsx' ? (
                                    <FaFileExcel className='text-5xl text-[#008000] m-auto' />
                                  ) : (
                                    <FaFileAlt className='text-5xl text-[#0070e7] m-auto' />
                                  )}
                                  <p className='text-xs m-auto pt-2 text-gray-500'>{currentFile.name}</p>
                                </>
                              ) : (
                                <>
                                  <FaFileAlt className='text-4xl text-gray-400 m-auto' />
                                  <p className='py-2 text-gray-600'>Select your Document file</p>
                                  <button
                                    className='btn btn-primary m-auto flex flex-row'
                                    onClick={triggerFileInput}
                                  >
                                    Choose File <FaFolderOpen className='m-auto ml-2' />
                                  </button>
                                  <input
                                    ref={fileInputRef}
                                    type="file"
                                    onChange={handleFileChange}
                                    className='opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer'
                                  />
                                </>
                              )}
                            </div>
                          </div>

                          <div className="flex justify-end mt-4">
                            <Button
                              type="submit"
                              className="bg-[#0d6efd] mx-2 btn btn-sm text-white"
                              onClick={handleAddDocument}
                              disabled={!currentFile}
                            >
                              {isUploading ? 'Uploading...' : 'Upload & Add more'}
                            </Button>
                          </div>

                          {/* Uploaded/Pending Documents List */}
                          {uploadedFiles.length > 0 && (
                            <div className='mt-6'>
                              <h3 className='text-lg font-semibold mb-2'>Documents to be Uploaded:</h3>
                              <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3'>
                                {uploadedFiles.map((file, index) => (
                                  <div key={index} className={`border rounded-lg p-3 flex items-center justify-between ${file.status === 'uploaded' ? 'bg-green-50' : ''}`}>
                                    <div className='flex items-center'>
                                      {file.type === 'pdf' ? (
                                        <FaFilePdf className='text-3xl text-[#d10707] mr-3' />
                                      ) : ['gif', 'jpg', 'jpeg', 'png', 'webp'].includes(file.type) ? (
                                        <FaFileImage className='text-3xl text-[#e79d11] mr-3' />
                                      ) : file.type === 'xlsx' ? (
                                        <FaFileExcel className='text-3xl text-[#008000] mr-3' />
                                      ) : (
                                        <FaFileAlt className='text-3xl text-[#0070e7] mr-3' />
                                      )}
                                      <div>
                                        <p className='font-medium'>{file.title}</p>
                                        <p className='text-xs text-gray-500'>{file.name}</p>
                                        {file.status === 'uploaded' && (
                                          <span className='text-xs text-green-600'>Uploaded</span>
                                        )}
                                        {file.status === 'pending' && (
                                          <span className='text-xs text-yellow-600'>Pending</span>
                                        )}
                                      </div>
                                    </div>
                                    <button
                                      onClick={() => removeFile(index)}
                                      className='text-gray-500 hover:text-red-500'
                                    >
                                      <FaTimes />
                                    </button>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* Submit Button */}

                          {uploadedFiles.length > 0 && (

                            <div className="flex justify-end ">
                              <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleDocsSubmit}> Save & Next </Button>
                            </div>
                          )}
                        </div>
                      </div>}
                  </div>

                  {/* Product Document End */}

                  {/* Product Offers Start */}
                  <div className={`${(disabledStatus.productOffers) ? "bg-gray-200" : "bg-white"} my-2 rounded-md border-[1px] border-solid border-[#d2d2d2]`}>
                    <div className={`${!disabledStatus.productOffers ? "bg-[#e9f3fe]" : "my-3"} flex flex-row items-center py-3 `}>
                      {disabledStatus.productOffers && <FaLock className='text-gray-400 mx-2' />}
                      <h5 className={`${disabledStatus.productOffers ? "text-gray-400" : "text-black"} mx-3 capitalize text-md font-semibold`}> Product Offers </h5>
                    </div>

                    {!disabledStatus.productDocument &&
                      <div className='p-3'>
                        <form method='POST' onSubmit={handleofferssubmit}>
                          {offerdata.map((val, i) =>
                            <div className='row' key={i}>
                              <div className="grid grid-cols-1">
                                <div>
                                  <label className="block my-2">
                                    <span className="block text-sm font-medium text-slate-700">Offer Detail {i + 1}</span>
                                  </label>
                                  <div className='bg-transparent mb-1 flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                    <TbTriangleSquareCircle className='text-theme-color-yellow' />
                                    <input
                                      className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6"
                                      type="text"
                                      name="offers"
                                      id="offers"
                                      placeholder="Enter Product offer"
                                      autoComplete="new-password"
                                      value={values.offers}
                                      onChange={(e) => handleofferChange(e, i)}
                                    />
                                    {/* Only show delete button if it's not the first offer */}
                                    {i > 0 && (
                                      <button
                                        type="button"
                                        className='flex flex-row rounded-full py-3 text-red-700'
                                        onClick={() => handleofferDelete(i)}
                                      >
                                        <FaTrash />
                                      </button>
                                    )}
                                    {error.offers &&
                                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                    }
                                  </div>
                                  {error.offers &&
                                    <p className='my-2 px-2 text-red-600 text-xs'>{error.offers}</p>
                                  }
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Add More button */}
                          <button
                            type="button"
                            className="my-2 flex flex-row items-center bg-blue-700 p-2 rounded-md text-white"
                            onClick={handleofferClick}
                          >
                            <FaPlus className='m-1' />
                            <span>Add New Offer</span>
                          </button>

                          <div className="flex justify-end">
                            <Button
                              type="button"
                              className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end"
                              onClick={handleofferssubmit}
                            >
                              Save & Next
                            </Button>
                          </div>
                        </form>
                      </div>
                    }
                  </div>
                  {/* Product offers End */}
                </div>
                <div className='flex flex-row justify-end items-center my-1'>
                  <div className="flex flex-row items-center gap-6 p-3 bg-gray-50 rounded-lg">
                    {/* Visible Switch */}
                    <label className="flex items-center gap-3 cursor-pointer group">
                      <div className="relative">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={isVariantVisible}
                          onChange={handleToggleVariantVisible}
                          aria-labelledby="visible-label"
                        />
                        <div className={`
        w-12 h-6 rounded-full shadow-inner transition-colors duration-300
        peer-checked:bg-blue-500 bg-gray-300
        peer-focus-visible:ring-2 peer-focus-visible:ring-blue-500
      `}></div>
                        <div className={`
        absolute left-1 top-1 w-4 h-4 rounded-full bg-white shadow-md
        transition-all duration-300 transform
        peer-checked:translate-x-6
      `}></div>
                      </div>
                      <span id="visible-label" className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                        Visible
                      </span>
                    </label>

                    {/* Active Switch */}
                    <label className="flex items-center gap-3 cursor-pointer group">
                      <div className="relative">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={isVariantActive}
                          onChange={handleToggleVariantActive}
                          aria-labelledby="active-label"
                        />
                        <div className={`
        w-12 h-6 rounded-full shadow-inner transition-colors duration-300
        peer-checked:bg-emerald-500 bg-gray-300
        peer-focus-visible:ring-2 peer-focus-visible:ring-emerald-500
      `}></div>
                        <div className={`
        absolute left-1 top-1 w-4 h-4 rounded-full bg-white shadow-md
        transition-all duration-300 transform
        peer-checked:translate-x-6
      `}></div>
                      </div>
                      <span id="active-label" className="text-sm font-medium text-gray-700 group-hover:text-gray-900">
                        Active
                      </span>
                    </label>
                  </div>


         <button
  type="button"
  disabled={
    Object.entries(disabledStatus)
      .filter(
        ([key]) =>
          ![
            "productOffers",
            "productShortDescription",
            "productLongDescription",
          ].includes(key)
      )
      .some(([_, value]) => value === true)
  }
  className={`relative rounded-md group px-3 h-12 flex space-x-2 items-center w-[200px]
    ${
      Object.entries(disabledStatus)
        .filter(
          ([key]) =>
            ![
              "productOffers",
              "productShortDescription",
              "productLongDescription",
            ].includes(key)
        )
        .some(([_, value]) => value === true)
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-button-color hover:bg-button-color"
    }`}
  onClick={handlefinalProductSubmit}
>
  <span className="relative text-md text-black font-semibold pl-0">
    Publish Product
  </span>

<div
  className={`flex items-center h-12 w-12 rounded-full absolute right-[0px] z-20 drop-shadow-2xl
    ${
      Object.entries(disabledStatus)
        .filter(
          ([key]) =>
            ![
              "productOffers",
              "productShortDescription",
              "productLongDescription",
            ].includes(key)
        )
        .some(([_, value]) => value === true)
        ? "bg-gray-300"
        : "bg-button-color"
    }
  `}
>
  <FaEye
    className={`h-3 w-3 text-black translate-x-4 transition duration-300
      ${
        Object.entries(disabledStatus)
          .filter(
            ([key]) =>
              ![
                "productOffers",
                "productShortDescription",
                "productLongDescription",
              ].includes(key)
          )
          .some(([_, value]) => value === true)
          ? ""
          : "group-hover:scale-[2]"
      }
    `}
  />
</div>

</button>



                </div>
              </div>
            ) : (
              <div class="col-start-1 col-end-13  my-5 px-3">
                <div class="flex items-start p-3  bg-red-700  border-[1px] border-l-4 border-red-500 rounded-lg relative">
                  <div class="flex-shrink-0 text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentcolor" viewBox="0 0 24 24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm-1 15l-5-5 1.41-1.42L11 14.17l6.59-6.59L19 9z" />
                    </svg>
                  </div>
                  <div class="ml-3">
                    <h2 class="text-lg font-semibold text-white">New Plan Purchased 🎉</h2>
                    <p class="text-white">A new Plan has successfully completed a purchase.</p>
                  </div>
                  <div class="ml-auto">
                    <button class="bg-white text-blue-600 font-medium px-4 py-2 rounded-lg border border-blue-600 hover:bg-blue-50 transition"
                      onClick={() => { navigatePlans(type) }}
                    >
                      Buy Purchase Plan
                    </button></div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>


      <Modal size="xl" show={variationmodalShow} onHide={() => handlevariationmodalhide()} aria-labelledby="example-modal-sizes-title-lg">
        <Modal.Body>
          <div className="relative border-b border-slate-200/60 py-3">
            <label className=" text-lg"> Add New Variant</label>
            <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => handlevariationmodalhide()}> ESC </div>
          </div>

          <div className='p-3'>
            <form method='POST'>
              <div className='row'>
                <div className="container m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-2">
                  {userAttributesarray.includes('4') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Selling Units </span>
                      <Tippy content={<span> The selling unit refers to the specific measurement or denomination in which a product is marketed and sold. This could encompass a wide range of units tailored to the product's characteristics, including familiar ones like pieces, liters, kilograms, grams, milliliters, and any other appropriate unit pertinent to the item's nature and market context. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <FaBoxOpen className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6"
                        type="text"
                        name="sellingUnit"
                        id="sellingUnit"
                        placeholder="Enter Product Selling Units"
                        autoComplete="new-password"
                        value={variantvalues.sellingUnit}
                        onChange={handleSellingUnit}
                        onKeyDown={(e) => {
                          // Allow navigation and editing keys
                          if (
                            ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Escape', 'Enter'].includes(e.key)
                          ) {
                            return;
                          }

                          // Only allow numeric keys
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                      {variantError.sellingUnit &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.sellingUnit &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.sellingUnit}</p>
                    }</div> : null}

                  {userAttributesarray.includes('16') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Selling Unit Packing Type </span>
                      <Tippy content={<span> type of packing refers to the method or container used to package products for shipping or delivery, including boxes, crates, cartons, pallets, envelopes, or other suitable materials. It's essential for efficient logistics, accurate shipping cost calculation, proper product handling during transit, and effective inventory management. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class=' bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md '>
                      <TbTriangleSquareCircle className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="sellingUnitPackingType"
                        id="sellingUnitPackingType"
                        placeholder="Enter Selling Unit Packing Type"
                        autoComplete="new-password"
                        value={variantvalues.sellingUnitPackingType}
                        onChange={handleVariantInput}
                      />
                      {variantError.sellingUnitPackingType &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.sellingUnitPackingType &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.sellingUnitPackingType}</p>
                    }
                  </div> : null}



                  {userAttributesarray.includes('17') ? (
                    <div>
                      <label className="my-3 flex flex-row">
                        <span className="block text-sm font-medium text-slate-700">Selling Measurement</span>
                        <Tippy content={<span> SKU stands for Stock Keeping Unit, which is a unique identifier used in retail and manufacturing to keep track of inventory </span>}>
                          <button type="button" className="mx-3"><MdInfo /></button>
                        </Tippy>
                      </label>
                      <Select onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }} options={measurementdata} placeholder="Select Packing Type" onChange={handlepackingtype} />
                    </div>
                  ) : null}

                  {/* <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} options={packingtypedata} placeholder="Select Packing Type" onChange={handlepackingtype} /> */}


                  {userAttributesarray.includes('6') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Shipping Units  </span>
                      <Tippy content={<span> A shipping unit refers to the quantity of individual units that are packed together in a container such as a box, carton, crate, pallet, bag, or any other packaging material for the purpose of transportation and sale to the customer. This bundled packaging is typically sold to the customer in its entirety, rather than being broken down into smaller quantities.  </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <FaBoxOpen className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6"
                        type="text"
                        name="ShippingUnit"
                        id="ShippingUnit"
                        placeholder="Enter Product ShippingUnit"
                        autoComplete="new-password"
                        value={values.ShippingUnit}
                        onChange={handleSellingUnit}
                        onKeyDown={(e) => {
                          if (
                            ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Escape', 'Enter'].includes(e.key)
                          ) return;

                          if (!/[0-9]/.test(e.key)) e.preventDefault();
                        }}
                      />
                      {variantError.ShippingUnit &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.ShippingUnit &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.ShippingUnit}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('18') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Shipping Unit Packing Type </span>
                      <Tippy content={<span> type of packing refers to the method or container used to package products for shipping or delivery, including boxes, crates, cartons, pallets, envelopes, or other suitable materials. It's essential for efficient logistics, accurate shipping cost calculation, proper product handling during transit, and effective inventory management. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class=' bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md '>
                      <TbTriangleSquareCircle className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="shippingUnitPackingType"
                        id="shippingUnitPackingType"
                        placeholder="Enter Shipping Unit Packing Type"
                        autoComplete="new-password"
                        value={variantvalues.shippingUnitPackingType}
                        onChange={handleVariantInput}
                      />
                      {variantError.shippingUnitPackingType &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.shippingUnitPackingType &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.shippingUnitPackingType}</p>
                    }
                  </div> : null}
                  {userAttributesarray.includes('19') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Shipping Measurement</span>
                      <Tippy content={<span> SKU stands for Stock Keeping Unit, which is a unique identifier used in retail and manufacturing to keep track of inventory </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <Select onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }} options={measurementdata} placeholder="Select Packing Type" onChange={handleshippingpackingtype} />

                  </div> : null}

                  {userAttributesarray.includes('20') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Variant </span>
                      <Tippy content={<span> a product variant refers to a distinct version or option of a product with unique attributes such as size, color, or material. These variants allow businesses to manage inventory, pricing, and orders accurately, catering to diverse customer preferences and streamlining sales processes. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class=' bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md '>
                      <TbTriangleSquareCircle className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productVariant"
                        id="productVariant"
                        placeholder="Enter Product variant"
                        autoComplete="new-password"
                        value={variantvalues.productVariant}
                        onChange={handleVariantInput}
                      />
                      {variantError.productVariant &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.productVariant &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productVariant}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('21') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">HSN Code </span>
                      <Tippy content={<span> SKU stands for Stock Keeping Unit, which is a unique identifier used in retail and manufacturing to keep track of inventory </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <TbNumbers className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productHSN"
                        id="productHSN"
                        placeholder="Enter Product HSN Code"
                        autoComplete="new-password"
                        value={variantvalues.productHSN}
                        onChange={handleVariantInput}
                      />
                      {variantError.productHSN &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.CategoryName1 &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productHSN}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('22') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700"> Best Before / Expiry </span>
                      <Tippy content={<span> Expiry and best before dates are key indicators of product freshness and safety. The expiry date marks the point after which a product may pose health risks, while the best before date signifies when a product's optimal quality diminishes. Both dates are crucial for managing inventory effectively, minimizing waste, and ensuring customer satisfaction by delivering products with adequate shelf life. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <MdDomainVerification className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productWarenty"
                        id="productWarenty"
                        placeholder="Enter Product Warrenty"
                        autoComplete="new-password"
                        value={variantvalues.productWarenty}
                        onChange={handleVariantInput}
                      />
                      {variantError.productWarenty &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.productWarenty &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productWarenty}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('23') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Minimum Order Quantity </span>
                      <Tippy content={<span> MOQ stands for "Minimum Order Quantity," defining the minimum quantity of a product a customer must purchase in one order.  It's set by the seller to optimize efficiency.  It must be in multiplication of Shipping Unit. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <BiCategory className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productMOQ"
                        id="productMOQ"
                        placeholder="Enter Product MOQ"
                        autoComplete="new-password"
                        value={variantvalues.productMOQ}
                        onChange={handleVariantInput}
                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                      />
                      {variantError.productMOQ &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.productMOQ &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productMOQ}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('24') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Product id </span>
                      <Tippy content={<span> Product ID is a user-defined alphanumeric code that uniquely identifies a product based on its type, size, color, weight, packaging, or other criteria set by the user. These IDs streamline inventory management, facilitate order processing, and enable accurate product tracking throughout the sales cycle. </span>}><button type="button" className="mx-3"><MdInfo /></button></Tippy>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <BiCategory className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productID"
                        id="productID"
                        placeholder="Enter Product ID"
                        autoComplete="new-password"
                        value={variantvalues.productID}
                        onChange={handleVariantInput}
                      />
                      {variantError.productID &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.productID &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productID}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('25') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">MRP </span>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <BiCategory className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productMRP"
                        id="productMRP"
                        placeholder="Enter MRP"
                        autoComplete="new-password"
                        value={variantvalues.productMRP}
                        onChange={handleVariantInput}
                      />
                      {variantError.productMRP &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.productMRP &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productMRP}</p>
                    }
                  </div> : null}

                  {userAttributesarray.includes('26') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Price </span>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <BiCategory className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="productPrice"
                        id="productPrice"
                        placeholder="Enter Product Price"
                        autoComplete="new-password"
                        value={variantvalues.productPrice}
                        onChange={handleVariantInput}
                        onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                      />
                      {variantError.productPrice &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.productPrice &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.productPrice}</p>
                    }
                  </div> : null}


                  {userAttributesarray.includes('28') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Link </span>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <BiCategory className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="Link"
                        id="Link"
                        placeholder="Enter product Link "
                        autoComplete="new-password"
                        value={variantvalues.Link}
                        onChange={handleVariantInput}

                      />
                      {variantError.Link &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {variantError.Link &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{variantError.Link}</p>
                    }
                  </div> : null}

                  {/* {userAttributesarray.includes('27') ? <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700"> Available Stock </span>
                    </label>
                    <div class='bg-transparent mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                      <BiCategory className='text-theme-color-yellow' />
                      <input
                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                        type="text"
                        name="Stock"
                        id="Stock"
                        placeholder="Enter product Link "
                        autoComplete="new-password"
                        value={variantvalues.Stock}
                        onChange={handleVariantInput}

                      />
                      {error.Stock &&
                        <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                      }
                    </div>
                    {error.Stock &&
                      <p className='my-2 px-2 text-red-600 text-xs'>{error.Stock}</p>
                    }
                  </div> : null} */}


                  <div>
                    <label className="my-3 flex flex-row">
                      <span className="block text-sm font-medium text-slate-700">Product variant Image </span>
                    </label>
                    <input type="file" className="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-theme-color-yellow hover:file:bg-violet-100"
                      name="VariantImg"
                      id="VariantImg"
                      onChange={handleVariantPhotoUpload}
                    // onChange={handleonchange}
                    />
                    {/* <input type="file" name="product_variant_image" onChange={handleonchange} /> */}
                  </div>
                </div>
                {/* <div className=" relative flex flex-row my-2 px-2">
                <label className="mx-2">
                  <input type="checkbox" value={isVariantVisible} onChange={handlecheckvariantvisible} name="variantvisible" id="variantvisible" className="mr-2" />
                  Visible </label>
                <label className="mx-2">
                  <input type="checkbox" value={isVariantActive} onChange={handlecheckvariantactive} name="variantstatus" id="variantstatus" className="mr-2" />
                  Active </label>
              </div> */}

                <div className="flex justify-end">
                  <button type="button" className="relative rounded-md group px-3 h-12 mt-5 ml-2 flex space-x-2 items-center bg-button-color  hover:bg-button-color w-[150px]" onClick={handlevariantSave}>
                    <span className="relative text-md text-black font-semibold pl-3">Submit</span>
                    <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                      <FaArrowAltCircleRight className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                    </div>
                  </button>

                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      {isLoading && (
        <div style={overlayStyle}>
          <div style={loaderStyle}>Loading...</div>
        </div>
      )}
    </div>
  )
}

export default AddProducts